"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactPanel = _interopRequireDefault(require("@adsk/alloy-react-panel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PanelBody = (0, _styledComponents.default)(_alloyReactPanel.default.Body)`
  display: flex;
  flex-direction: column;
  height: 100%;

  & > div:not(:last-child) {
    margin-bottom: 16px;
  }
`;
var _default = exports.default = PanelBody;